const cookieOperation = {

setCookie(name,value,days) 
{ 
    var expiresDays = (typeof days === 'number') ? days : 30; 
    var exp = new Date(); 
    exp.setTime(exp.getTime() + expiresDays * 24 * 60 * 60 * 1000); 
    var cookieStr = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/"; 
    // iOS / 微信 WebView：HTTPS 下必须带 Secure，否则 cookie 可能被直接丢弃；
    // SameSite=Lax 兼容微信内从其它页面跳转进来的场景，避免被当作跨站而拦截
    if (typeof location !== 'undefined' && location.protocol === 'https:') {
      cookieStr += ";Secure;SameSite=Lax";
    }
    document.cookie = cookieStr; 
},

 //读取cookie
getCookie(name) 
{ 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
　　 return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
},
removeCookie: function (key) {
  // 尝试多种 path 删除，兼容旧代码未指定 path=/ 时生成的 cookie（path 为当前页面路径）
  var paths = ['/', window.location.pathname, '/m', '/m/login', '/m/home', '/home', '/login'];
  var uniquePaths = [];
  for (var i = 0; i < paths.length; i++) {
    if (uniquePaths.indexOf(paths[i]) === -1) {
      uniquePaths.push(paths[i]);
    }
  }
  uniquePaths.forEach(function (p) {
    document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=' + p;
  });
}
}

export default {
  setCookie: cookieOperation.setCookie,
  getCookie: cookieOperation.getCookie,
  removeCookie: cookieOperation.removeCookie
};



// WEBPACK FOOTER //
// ./src/service/cookie.js